import React from 'react'

import AiDemoImg from './img/aidemo.png'

export const AiShowcase: React.FC = () => {
    return (
        <>
            <h1 className="font-bold text-2xl mt-10 text-center">
                Как работает справочник
            </h1>
            <div className="mt-6">
                <img src={AiDemoImg} alt="Пример AI справочника" />
            </div>
        </>
    )
}
